import { axiosOtherTrackerInstance } from "../../configs/AxiosInstance";

export const modifyTargetPlanWater = async (post, payload) => {
  try {
    const response = await post(`/modify-target-plan-water`, payload, {
      instance: axiosOtherTrackerInstance,
    });

    // ✅ Ensure it's counted as success if HTTP 200 or has valid data
    if (
      response &&
      (response.status === 200 || response.data || response.message)
    ) {
      return {
        success: true,
        message: response.message || "Target plan water updated successfully",
        data: {
          summary: response.summary || null,
          targetPlan: response.data?.target_plan || null,
          durations: response.data?.durations?.records || [],
          splits: response.data?.splits?.records || [],
        },
      };
    }

    return {
      success: false,
      message: response?.message || "Failed to modify target plan water",
    };
  } catch (error) {
    console.error("Error modifying target plan water:", error);
    return {
      success: false,
      message: error?.message || "Error modifying target plan water",
    };
  }
};
